import React, { Link } from 'react-router-dom'
import equipe from 'assets/images/equipe.jpg'

function Section() {
  return (
    <section id='quem-somos' className='flex w-full flex-col items-center justify-center gap-4 pb-20 pt-28 md:gap-8'>
      <div className='grid w-11/12 grid-cols-1 gap-8 md:w-10/12'>
        <div className='flex items-center gap-2 text-xl'>
          <Link to={'/'} className='transition-all duration-500 hover:text-blue'>
            Home
          </Link>
          <span>/</span>
          <Link to={'/quem-somos'} className='transition-all duration-500 hover:text-blue'>
            Quem Somos
          </Link>
        </div>

        <div className='grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8'>
          <picture className='animate-scale-in'>
            <img src={equipe} alt='Equipe Macias & Cruz' loading='lazy' className='w-full' />
          </picture>

          <div className='flex animate-slide-left flex-col gap-4'>
            <header>
              <h2 className='text-3xl font-semibold uppercase md:text-4xl'>Quem Somos</h2>
            </header>

            <p className='text-justify md:text-xl'>
              Há mais de duas décadas, a Advocacia Macias & Cruz é referência no mundo jurídico. Nossa equipe experiente
              oferece soluções jurídicas eficazes e estratégias personalizadas para empresas e indivíduos.
            </p>

            <p className='text-justify md:text-xl'>
              Nossa equipe é altamente qualificada e está comprometida em proteger seus interesses com soluções
              jurídicas, pautadas na ética e legalidade.
            </p>

            <p className='text-justify md:text-xl'>
              Macias & Cruz Advocacia é especializada na recuperação de ativos empresariais, abrangendo desde ações de
              reintegração de posse até questões complexas de arrendamento mercantil.
            </p>
          </div>
        </div>
        <div className='flex animate-slide-right flex-col gap-4'>
          <article className='flex flex-col gap-2'>
            <header>
              <h2 className='text-3xl font-semibold uppercase'>Missão</h2>
            </header>
            <p className='text-justify md:text-2xl'>
              Oferecer soluções jurídicas completas e integradas, assegurando a eficiência e pontualidade na entrega da
              prestação jurisdicional.
            </p>
          </article>

          <article className='flex flex-col gap-2'>
            <header>
              <h2 className='text-3xl font-semibold uppercase'>Visão</h2>
            </header>
            <p className='text-justify md:text-2xl'>
              Ser reconhecida como advocacia parceira de grande relevo, destacando-se pela direção estratégica e
              eficiência nos serviços judiciais, extrajudiciais e de consultoria especializada.
            </p>
          </article>

          <article className='flex flex-col gap-2'>
            <header>
              <h2 className='text-3xl font-semibold uppercase'>Valores</h2>
            </header>
            <p className='text-justify md:text-2xl'>
              Agimos sempre com ética e integridade, respeitando os princípios legais e morais em todas as nossas
              interações, em um posicionamento estratégico que reflete nossa dedicação à excelência.
            </p>
          </article>
        </div>
      </div>
    </section>
  )
}

export default Section
